import React, { useState, useContext, useEffect } from 'react'
import Table from 'vendors/table'
import AmountFilter from 'shared/filters/AmountNew'
import TransactionCount from '../shared/filters/transactions-count'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FormControl from 'react-bootstrap/FormControl'
import InputGroup from 'react-bootstrap/InputGroup'
import Page from 'layout/page'
import PageTitle from 'layout/page-title'
import { useDebounce } from 'api/hooks/use-debounce'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import MoreFilters from './MoreFilters'
import Status from './Status'
import VendorType from './VendorType'
import UserContext from 'context/user-context'
import FilterContext from 'context/filters-context'

function Vendors() {
  const { filters, setFilters } = useContext(FilterContext)
  const emptyState = filters.vendors || {
    page: 1,
    perPage: 25,
    search: '',
    status: '',
    orderBy: 'risk_rate',
    orderDirection: 'desc',
    invoiceMinimumAmount: '',
    invoiceMaximumAmount: '',
    checkMinimumAmount: '',
    checkMaximumAmount: '',
    transactionsCount: '',
    vendorType: '',
    excludePcard: false,
    stale: false,
    recentPaymentChange: false,
    po_box: false,
    one_eight_hundred_number: false,
    duplicate_ein: false,
    duplicate_ein_being_paid: false,
  }
  const [search, setSearch] = useState(emptyState.search)
  const debouncedSearch = useDebounce(search, 300)
  const [params, setParams] = useState(emptyState)
  const { municipality_name } = useContext(UserContext)

  useEffect(() => {
    setFilters((f) => ({ ...f, vendors: params }))
  }, [params, setFilters])

  return (
    <Page title="Vendors">
      <PageTitle />
      <Row>
        <Col sm="4">
          <InputGroup className="mb-3">
            <InputGroup.Text>
              <FontAwesomeIcon icon={faSearch} />
            </InputGroup.Text>
            <FormControl
              name="vendor-search"
              placeholder="Search Vendor Name/ID"
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col sm="auto">
          <Status params={params} setParams={setParams} />
        </Col>
        {['College Station', 'Sarpy County'].includes(municipality_name) && (
          <Col sm="auto">
            <VendorType params={params} setParams={setParams} />
          </Col>
        )}
        <Col sm="auto">
          {/* TODO: Update filter for invoice amount and check amount (2 or 1?) */}
          <AmountFilter
            params={params}
            setParams={setParams}
            accessorMin="invoiceMinimumAmount"
            accessorMax="invoiceMaximumAmount"
          />
        </Col>
        <Col sm="auto">
          <TransactionCount
            filterParams={params}
            setFilterParams={setParams}
          />
        </Col>
        <Col>
          <MoreFilters params={params} setParams={setParams} />
        </Col>
      </Row>

      <Table
        setFilterParams={setParams}
        filterParams={params}
        debouncedSearch={debouncedSearch}
      />
    </Page>
  )
}

export default Vendors
